"use client";

import { AppNav } from "@/components/AppNav";

export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="px-6 pt-4 flex justify-center print:hidden">
        <AppNav />
      </div>
      {children}
    </div>
  );
}
